<div class="tests-container" snAssistantSurface="testList" surfaceTitle="Tests">
  <div class="tests-header">
    <div class="title-section">
      <h1 i18n="@@tests.title">Tests</h1>
      <p class="subtitle" i18n="@@tests.subtitle">Create and manage agent evaluation tests</p>
    </div>
    <div class="actions-section">
      <p-button
        i18n-label="@@tests.new"
        label="New test"
        icon="pi pi-plus"
        (click)="createNewTest()">
      </p-button>
    </div>
  </div>

  <p-tabs [value]="activeTab()" (valueChange)="onTabChange($any($event))" styleClass="tests-tabs">
    <p-tablist>
      <p-tab value="all" i18n="@@tests.tab.all">All Tests</p-tab>
      <p-tab value="past" i18n="@@tests.tab.past">Past Run Analysis</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="all">

  <div class="filter-section">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        pInputText
        type="text"
        i18n-placeholder="@@tests.search"
        placeholder="Search tests…"
        [ngModel]="searchTerm()"
        (ngModelChange)="searchTerm.set($event)"
        snAssistantSkip
        class="search-input">
    </div>
    <p-select
      [options]="typeOptions"
      [ngModel]="typeFilter()"
      (ngModelChange)="typeFilter.set($event); onTypeFilterChange()"
      snAssistantSkip
      optionLabel="label"
      optionValue="value"
      i18n-placeholder="@@tests.filter.placeholder"
      placeholder="Filter by type"
      class="type-filter">
    </p-select>
  </div>

  <div class="table-section">
    <p-table
      [value]="filteredTests()"
      [loading]="loading()"
      styleClass="tests-table">

      <ng-template pTemplate="header">
        <tr>
          <th i18n="@@tests.col.name">Name</th>
          <th i18n="@@tests.col.type">Type</th>
          <th class="hide-mobile" i18n="@@tests.col.description">Description</th>
          <th class="hide-mobile" i18n="@@tests.col.updatedAt">Updated</th>
          <th></th>
          <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-test>
        <tr class="clickable-row" (click)="editTest(test)">
          <td>
            <div class="test-name">{{ test.name || '-' }}</div>
          </td>
          <td>
            <p-tag [value]="typeLabel(test.type)" [severity]="typeSeverity(test.type)"></p-tag>
          </td>
          <td class="hide-mobile">
            <div class="test-description">{{ test.description || '-' }}</div>
          </td>
          <td class="hide-mobile">
            <div class="test-updated">{{ formatDate(test.updated_at) }}</div>
          </td>
          <td class="run-cell" (click)="$event.stopPropagation()">
            <span class="run-button-desktop">
              <p-button
                i18n-label="@@tests.start"
                label="Start test"
                icon="pi pi-play"
                size="small"
                (click)="runTest(test)">
              </p-button>
            </span>
            <span class="run-button-mobile">
              <p-button
                icon="pi pi-play"
                size="small"
                i18n-pTooltip="@@tests.start"
                pTooltip="Start test"
                tooltipPosition="top"
                (click)="runTest(test)"
                i18n-ariaLabel="@@tests.start"
                ariaLabel="Start test">
              </p-button>
            </span>
          </td>
          <td class="actions-cell">
            <p-button
              icon="pi pi-pencil"
              [text]="true"
              severity="secondary"
              size="small"
              i18n-pTooltip="@@common.edit"
              pTooltip="Edit"
              tooltipPosition="top"
              (click)="$event.stopPropagation(); editTest(test)"
              i18n-ariaLabel="@@common.edit"
              ariaLabel="Edit">
            </p-button>
            <p-button
              icon="pi pi-trash"
              [text]="true"
              severity="danger"
              size="small"
              i18n-pTooltip="@@common.delete"
              pTooltip="Delete"
              tooltipPosition="top"
              (click)="askDelete(test, $event)"
              i18n-ariaLabel="@@common.delete"
              ariaLabel="Delete">
            </p-button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="empty-message" i18n="@@tests.empty">
            No tests found
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

      </p-tabpanel>

      <p-tabpanel value="past">
        <div class="runs-toolbar">
          <p-button
            icon="pi pi-refresh"
            i18n-label="@@tests.runs.refresh"
            label="Refresh"
            severity="secondary"
            [outlined]="true"
            size="small"
            [loading]="runsLoading()"
            (click)="refreshTestRuns()">
          </p-button>
        </div>

        <div class="table-section">
          <p-table
            [value]="testRuns()"
            [loading]="runsLoading()"
            dataKey="id"
            styleClass="tests-table tests-runs-table">

            <ng-template pTemplate="header">
              <tr>
                <th class="toggler-col"></th>
                <th i18n="@@tests.runs.col.date">Date</th>
                <th class="hide-mobile" i18n="@@tests.runs.col.agent">Agent</th>
                <th class="hide-mobile" i18n="@@tests.runs.col.creator">Started by</th>
                <th class="hide-mobile" i18n="@@tests.runs.col.total">Sessions</th>
                <th i18n="@@tests.runs.col.breakdown">Result</th>
                <th i18n="@@tests.runs.col.status">Status</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-run>
              <tr>
                <td class="toggler-col">
                  @if (runSessionsLoading()[run.id]) {
                    <i class="pi pi-spin pi-spinner toggler-spinner"></i>
                  } @else {
                    <p-button
                      type="button"
                      [text]="true"
                      [rounded]="true"
                      severity="secondary"
                      size="small"
                      [icon]="expandedRows()[run.id] ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                      (click)="toggleRunExpansion(run)">
                    </p-button>
                  }
                </td>
                <td>
                  <div class="test-updated">{{ formatDate(run.created_at) }}</div>
                </td>
                <td class="hide-mobile">
                  <div class="test-name">{{ agentName(run.agent_id) }}</div>
                </td>
                <td class="test-updated hide-mobile">{{ run.created_by_email || '-' }}</td>
                <td
                  class="hide-mobile"
                  [pTooltip]="run.test_names?.length ? run.test_names.join('\n') : null"
                  tooltipPosition="top"
                  [tooltipStyleClass]="'test-names-tt'">
                  {{ run.total_sessions ?? 0 }}
                </td>
                <td>
                  <div class="run-breakdown">
                    @if (run.success_sessions > 0) {
                      <span class="run-stat ok" i18n-pTooltip="@@tests.runs.success" pTooltip="Success" tooltipPosition="top">
                        <i class="pi pi-check-circle"></i> {{ run.success_sessions }}
                      </span>
                    }
                    @if (run.failed_sessions > 0) {
                      <span class="run-stat fail" i18n-pTooltip="@@tests.runs.failed" pTooltip="Failed" tooltipPosition="top">
                        <i class="pi pi-times-circle"></i> {{ run.failed_sessions }}
                      </span>
                    }
                    @if (run.processing_sessions > 0) {
                      <span class="run-stat proc" i18n-pTooltip="@@tests.runs.processing" pTooltip="Processing" tooltipPosition="top">
                        <i class="pi pi-spin pi-spinner"></i> {{ run.processing_sessions }}
                      </span>
                    }
                    @if ((run.success_sessions ?? 0) === 0 && (run.failed_sessions ?? 0) === 0 && (run.processing_sessions ?? 0) === 0) {
                      <span class="run-stat proc">—</span>
                    }
                  </div>
                </td>
                <td>
                  <p-tag [value]="runStatusLabel(run)" [severity]="runStatusSeverity(run)"></p-tag>
                </td>
              </tr>

              <!-- Expanded sessions (inline, same body template) -->
              @if (expandedRows()[run.id] && !runSessionsLoading()[run.id]) {
                @let sessions = sessionsFor(run.id);
                <tr class="run-expansion-row">
                  <td colspan="7">
                    @if (sessions.length === 0) {
                      <div class="run-sessions-empty" i18n="@@tests.runs.sessions.empty">No sessions in this run</div>
                    } @else {
                      <table class="run-sessions-table">
                        <thead>
                          <tr>
                            <th i18n="@@tests.runs.sessions.col.date">Session date</th>
                            <th i18n="@@tests.runs.sessions.col.test">Test</th>
                            <th i18n="@@tests.runs.sessions.col.status">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (s of sessions; track s.id) {
                            <tr
                              class="session-row"
                              [routerLink]="['/agents', run.agent_id, 'conversations', s.id]">
                              <td>{{ formatDate(s.created_at) }}</td>
                              <td>
                                @if (s.test_id) {
                                  <a
                                    [routerLink]="['/tests', s.test_id]"
                                    class="test-link"
                                    (click)="$event.stopPropagation()">
                                    @if (s.test_name) {
                                      {{ s.test_name }}
                                    } @else {
                                      <span i18n="@@tests.runs.sessions.testUnknown">Unknown</span>
                                    }
                                  </a>
                                } @else {
                                  -
                                }
                              </td>
                              <td>
                                <p-tag
                                  [value]="testStatusLabel(s.test_status)"
                                  [severity]="testStatusSeverity(s.test_status)">
                                </p-tag>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                  </td>
                </tr>
              }
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="empty-message" i18n="@@tests.runs.empty">
                  No test runs yet
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        @if (runsNextCursor()) {
          <div class="runs-loadmore">
            <p-button
              i18n-label="@@tests.runs.loadMore"
              label="Load more"
              severity="secondary"
              [text]="true"
              [loading]="runsLoading()"
              (click)="loadMoreTestRuns()">
            </p-button>
          </div>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <app-delete-confirmation
    [(visible)]="showDeleteDialog"
    [title]="deleteTitle"
    [subtitle]="deleteSubtitle()"
    [deleting]="isDeleting()"
    (confirm)="onDeleteConfirm()">
  </app-delete-confirmation>

  <app-run-test-drawer
    [(visible)]="runDrawerVisible"
    [testId]="runTestId()"
    [testName]="runTestName()">
  </app-run-test-drawer>
</div>
